export default __webpack_public_path__ + "static/media/009-little red riding hood.d7be8c70.svg";